import { Icon, ImageFallback, HStack, VStack } from '@genial/components';
import { BoxRadius, Color, ColorTypes, Spacing, Typography } from '@genial/design-tokens';
import { EquityEntity } from '@genial/services';
import { Utils } from '@genial/utils';
import { Tooltip, Text } from 'native-base';
import React from 'react';

import { LoadingOffer } from './loading';

interface OfferProps extends EquityEntity {
  isLoading: boolean;
}

export const Offer: React.FC<OfferProps> = ({
  quote: {
    icons: { light: image },
    productName,
    symbol,
    lastPrice,
    priceChangeTax,
    tradeDate,
  },
  isLoading,
}) => {
  if (isLoading) {
    return <LoadingOffer />;
  }

  const priceChangeTaxValue = priceChangeTax;
  const priceChangeTaxIsPositive = priceChangeTaxValue >= 0;
  const iconColorPositive = 'feedback.success.default';
  const iconColorNegative = 'feedback.error.default';
  const iconColor = priceChangeTaxIsPositive ? iconColorPositive : iconColorNegative;

  return (
    <HStack alignItems="center" justifyContent="space-between">
      <HStack alignItems="center" space={Spacing['inline.xxxs']}>
        <ImageFallback
          src={image || ''}
          alt="logo"
          width="54px"
          height="48px"
          testID="product-img"
          resizeMode="cover"
          borderRadius={BoxRadius.sm}
          resizeMethod="scale"
        />
        <Tooltip testID="qa" label="Petrobras">
          <VStack>
            <Text
              variant="semibold"
              fontSize={Typography['fontsize.md']}
              color="neutral.darkest"
              noOfLines={1}>
              {productName}
            </Text>
            <Text variant="regular" fontSize={Typography['fontsize.md']} color="neutral.darkest">
              {symbol}
            </Text>
          </VStack>
        </Tooltip>
      </HStack>
      <VStack space={Spacing['inline.quarck']}>
        <Text variant="regular" fontSize={Typography['fontsize.md']} color="neutral.black">
          Último preço
        </Text>
        <HStack space={Spacing['inline.nano']} alignItems="center">
          <Text variant="regular" fontSize={Typography['fontsize.md']} color="neutral.darkest">
            {Utils.Mask.Money(lastPrice)}
          </Text>
          <HStack alignItems="center" justifyContent="center">
            {priceChangeTaxValue !== 0 && (
              <Icon
                name={priceChangeTaxValue >= 0 ? 'ArrowUp' : 'ArrowDown'}
                size="xxxxxs"
                color={Color[iconColor] as ColorTypes.Option}
                testID="last-price-arrow"
              />
            )}

            <Text
              variant="regular"
              fontSize={Typography['fontsize.md']}
              color={
                priceChangeTaxValue === 0 ? 'neutral.black' : (iconColor as ColorTypes.Option)
              }>
              {Utils.Mask.Percentage(priceChangeTaxValue)}
            </Text>
          </HStack>
        </HStack>
        <Text variant="regular" fontSize={Typography['fontsize.xs']} color="neutral.medium">
          Atualizado às {Utils.Mask.DateFormat(tradeDate, 'HH:mm')}
        </Text>
      </VStack>
    </HStack>
  );
};
